import { cn } from '@/lib/cn';
import type { ProcedureType } from '@/services/procedure-template.service';

interface Props {
  procedureType: ProcedureType;
  className?: string;
}

export function ProcedureTypeBadge({ procedureType, className }: Props) {
  const isInspection = procedureType === 'INSPECTION';
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        isInspection
          ? 'bg-primary/10 text-primary border border-primary/30'
          : 'bg-sky-500/10 text-sky-700 border border-sky-300/40',
        className,
      )}
    >
      {isInspection ? 'Inspection' : 'Service'}
    </span>
  );
}
